import * as Yup from 'yup';
import { getValidationRules } from '../../utils/validation';
import { contact } from './content.json';

export const validation = Yup.object().shape({
  ...getValidationRules(contact)
});
